import { AbstractEntity } from "../AbstractEntity";
export default class VesselClass extends AbstractEntity {
    vesselClass;
    constructor(vesselClass) {
        super();
        this.vesselClass = vesselClass;
    }
}
//# sourceMappingURL=VesselClass.js.map